import { VIEW_MODES } from '../utils/viewMode';

const BOUTONS = [
    { mode: VIEW_MODES.mosaic, libelle: 'Mosaïque', icone: 'fa-th-large' },
    { mode: VIEW_MODES.list, libelle: 'Liste', icone: 'fa-list' },
];

function ViewModeToggle({ mode, onChange }) {
    return (
        <div className="buttons has-addons mb-4">
            {BOUTONS.map((bouton) => {
                const estActif = mode === bouton.mode;

                return (
                    <button
                        key={bouton.mode}
                        type="button"
                        className={`button ${estActif ? 'is-dark is-selected' : ''}`}
                        onClick={() => onChange(bouton.mode)}
                        aria-pressed={estActif}
                    >
                        <span className="icon">
                            <i className={`fas ${bouton.icone}`} aria-hidden="true"></i>
                        </span>
                        <span>{bouton.libelle}</span>
                    </button>
                );
            })}
        </div>
    );
}

export default ViewModeToggle;
